import React from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'

// import { css } from '@styled-system/css'
import { css } from '@emotion/react'
import { useTheme } from '@chakra-ui/react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'

export const BackButton: React.FC<ButtonProps> = (props) => {
  const { ...rest } = props

  const theme: any = useTheme()
  const navigate = useNavigate()
  const BackButtonStyles = css`
    background: none;
    color: ${theme.colors.eastBay04};
    transition: all 0.2s ease;
    display: inline;
    &:hover {
      cursor: pointer;
      transform: scale(1.008);
      color: ${theme.colors.primary};
      & > svg {
        opacity: 1;
      }
    }
  ` as any

  return (
    <Button
      {...rest}
      css={BackButtonStyles}
      onClick={() => navigate && navigate(-1)}
    >
      <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '5' }} />
      {props.children}
    </Button>
  )
}
